import React from 'react';

export default function ElephantBadgeIcon({ size = 64, className, pink }) {
  const big = size >= 80;
  const src = pink
    ? (big ? '/elephant-big_rose.png' : '/elephant-small_rose.png')
    : (big ? '/elephant-big.png' : '/elephant-small.png');
  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      className={className}
      style={{ display: 'inline-block', objectFit: 'contain' }}
    />
  );
}
